import React from "react";
import "./PDFViewerPage.css";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import handbookImgSi from "../../assets/HomeSection/handbook-imgsi.png";
import handbookImgEn from "../../assets/HomeSection/handbook-imgen.png";
import handbookImgTi from "../../assets/HomeSection/handbook-imgti.png";
import { useDispatch } from "react-redux";
import { setLanguage } from "../../redux/languageSlice";
import { Container } from "react-bootstrap";

const StyledWrapper = styled.div`
  .book {
    position: relative;
    border-radius: 10px;
    width: 220px;
    height: 300px;
    background-color: whitesmoke;
    box-shadow: 1px 1px 12px #000;

    transform-style: preserve-3d;
    perspective: 2000px;

    display: flex;
    align-items: center;
    justify-content: center;
    color: #000;
  }

  .cover {
    position: absolute;
    inset: 0;
    background-color: lightgray;
    border-radius: 10px;
    cursor: pointer;

    transition: all 0.5s;
    transform-origin: left;
    box-shadow: 1px 1px 12px #000;

    display: flex;
    align-items: center;
    justify-content: center;
    backface-visibility: hidden;
  }

  .book:hover .cover {
    transform: rotateY(-80deg);
  }

  p {
    font-size: 20px;
    font-weight: 700;
    margin: 0;
  }
`;

const PDFViewerPage = () => {
  const navigate = useNavigate();
   const dispatch = useDispatch();

  const hadaleReadBook = (lang) => {
    dispatch(setLanguage(lang));
    navigate("/read-driving-handbook");
   
  };

  return (
    <div className="container-fluid d-flex justify-content-center align-items-center min-vh-100 pt-5">
      <div className="drivers-handbook-page ">
        <h2 className="fs-1">
          Driving <span className="text-warning fw-bold">Handbook</span>
        </h2>
        <p className="drivers-handbook-title">
          සිංහල, தமிழ், English භාෂා සියල්ලෙන්ම අන්තර්ගත වේ
        </p>

        {/* ✅ CENTERED BOOK CONTAINER */}
        <div className="drivers-handbook-books">
          <StyledWrapper>
            <div
              className="book"
              onClick={() =>
                hadaleReadBook({ value: "sinhala", label: "සිංහල" })
              }
            >
              <p>සිංහල</p>
              <div className="cover">
                <img
                  src={handbookImgSi}
                  alt="drivers guide book sri lanka"
                  className="img-fluid rounded-4"
                  loading="lazy"
                />
              </div>
            </div>
          </StyledWrapper>

          <StyledWrapper>
            <div
              className="book"
              onClick={() =>
                hadaleReadBook({ value: "english", label: "English" })
              }
            >
              <p>English</p>
              <div className="cover">
                <img
                  src={handbookImgEn}
                  alt="drivers guide book sri lanka"
                  className="img-fluid rounded-4"
                  loading="lazy"
                />
              </div>
            </div>
          </StyledWrapper>

          <StyledWrapper>
            <div
              className="book"
              onClick={() => hadaleReadBook({ value: "tamil", label: "தமிழ்" })}
            >
              <p>தமிழ்</p>
              <div className="cover">
                <img
                  src={handbookImgTi}
                  alt="drivers guide book sri lanka"
                  className="img-fluid rounded-4"
                  loading="lazy"
                />
              </div>
            </div>
          </StyledWrapper>
        </div>
      </div>
    </div>
  );
};

export default PDFViewerPage;
